import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  .section-header {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

  h2 {
    font-size: clamp(2.6rem, 4vw, 3.2rem);
  }

  .eyebrow {
    text-transform: uppercase;
    letter-spacing: 0.18rem;
    color: var(--muted);
    font-weight: 600;
    font-size: 1.2rem;
  }

  .muted {
    color: var(--muted);
  }

  .visual-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 1.6rem;
    margin-top: 0.6rem;
  }

  .visual-card {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 18px;
    box-shadow: var(--shadow);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 14px 40px rgba(0, 0, 0, 0.3);
    }
  }

  .image-frame {
    position: relative;
    background: var(--pill-bg);
    border-bottom: 1px solid var(--border);

    img {
      display: block;
      width: 100%;
      height: auto;
    }

    .tag {
      position: absolute;
      top: 1rem;
      left: 1rem;
      padding: 0.6rem 1.2rem;
      border-radius: 999px;
      border: 1px solid var(--border);
      background: var(--pill-bg);
      font-weight: 700;
      font-size: 1.2rem;
      letter-spacing: 0.04rem;
    }
  }

  .card-body {
    padding: 1.6rem;
    display: grid;
    gap: 0.6rem;

    h3 {
      font-size: 1.8rem;
    }

    p {
      color: var(--muted);
      font-size: 1.4rem;
      line-height: 1.6;
    }
  }

  @media (max-width: 640px) {
    .visual-grid {
      gap: 1.2rem;
    }
  }
`
